<section [ngClass]="cardClass">
	<header [ngClass]="headerClass">
		<div class="flex items-start gap-3">
			<span [ngClass]="stepClass">
				<ng-container *ngIf="!isStepIcon; else iconStep">{{ stepLabel }}</ng-container>
				<ng-template #iconStep>
					<app-icon-reusable [icon]="stepIcon!" [size]="18" class="flex justify-center text-indigo600" [useCurrentColor]="true"></app-icon-reusable>
				</ng-template>
			</span>
			<div>
				<h2 [ngClass]="headingClass">{{ heading }}</h2>
				<p *ngIf="subheading" [ngClass]="subheadingClass">{{ subheading }}</p>
			</div>
		</div>

		<ng-content select="[form-card-actions]"></ng-content>
	</header>

	<div [ngClass]="contentClass">
		<ng-content></ng-content>
	</div>
</section>
